module.exports = __webpack_public_path__ + "static/media/codinov_logo1txt-white.bf80f966.svg";